module.exports = __webpack_public_path__ + "static/img/6.833c8951.png";